import React, {useRef, useEffect} from 'react';
import PhoneInput from 'react-phone-input-2';
import Typography from '@material-ui/core/Typography';
import 'react-phone-input-2/lib/style.css';
import { Field } from 'react-final-form';

const PhoneNumberField = (props) => {
  let latest_prefix=useRef();
  return (
    <div style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'5px'}}>
    <Field name={props.name}>{(f)=>{
      latest_prefix.current=getPrefix(f.input.value);
      
      return(
      <PhoneInput
        inputStyle={{height:'40px', width:'100%'}}
        value={f.input.value.replace('+', '')}
        disableDropdown={props.disabled}
        countryCodeEditable={true}
        enableSearch
        enableLongNumbers={true}
        disableInitialCountryGuess={(f.input.value[0]=='+')?false:true}
        onChange={(p)=>{if(p[0]!='+'){p='+'+p;} f.input.onChange(p)}}
        inputProps={{
          onPaste:(e)=>{e.preventDefault(); let p=e.clipboardData.getData('text/plain'); if(p.startsWith('00')){p='+'+p.slice(2);}if(p[0]!='+'){if(latest_prefix.current!=undefined){p=latest_prefix.current+p;}else{p='+'+p;}} latest_prefix.current=getPrefix(p); f.input.onChange(p)},
          name: props.name,
          disabled: props.disabled
        }}
      />
    )}}</Field>
    </div>
  );
  function getPrefix(n){
    n=n.replace('+', '');
    if(window.countries!=undefined){for(let c of window.countries){if(c.call_code!=null){for(let prefix of JSON.parse(c.call_code)){if(prefix[0]=='1'){prefix='1';} if(n.startsWith(prefix)){return '+'+prefix;}}}}}
  }
};

export default PhoneNumberField;
